import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledLink = styled.span`
    cursor: pointer;
    text-decoration: underline;
`;

export const SwitchContainer = styled.div`
    padding-bottom: 10px;
`;

export const StyledUserLink = styled(Link)`
    color: black;
    font-size: 16px;
`;
